import type { datadogRum } from '@datadog/browser-rum'
import type { DatadogUser, DatadogContext, UseDatadog } from '~~/layers/base/types/datadog'

export const useDatadog = (): UseDatadog => {
    const nuxtApp = useNuxtApp()

    // Datadog client instance (only on client)
    const dataDog: typeof datadogRum | null = import.meta.client
        ? (nuxtApp.$datadog as typeof datadogRum)
        : null

    /**
     * Log an error to Datadog with optional context
     * @param message - error message
     * @param context - additional key-value info
     */
    const logError = (error: Error, context: DatadogContext = {}): void => {
        if (!dataDog) return
        dataDog.addError(error, { ...context })
    }

    /**
     * Set the current user in Datadog
     * @param user - user info object
     */
    const setUser = (user: DatadogUser): void => {
        if (!dataDog) return
        dataDog.onReady(() => {
            dataDog.setUser(user)
        })
    }

    /**
     * Add a custom action to Datadog
     * @param name - action name
     * @param context - additional key-value context
     */
    const addAction = (name: string, context: DatadogContext = {}): void => {
        if (!dataDog) return
        dataDog.addAction(name, context)
    }

    return {
        logError,
        setUser,
        addAction,
    }
}
